import type { ConfirmDialogDesignTokens } from '@primeuix/themes/types/confirmdialog'

export default {
    icon: {
        size: '2rem',
        color: '{overlay.modal.color}',
    },
    content: {
        gap: '1rem',
    },
} satisfies ConfirmDialogDesignTokens
